<template>
  <section class="container">
    <PageLoader />

    <h1>{{ name }} bot</h1>
    <br />
    <img :src="avatar" alt="avatar" class="avatar" width="200" />
    <br /><br />
    <p style="font-weight: bold;">
      <font size="30px">
        <number v-if="animatedCounter" ref="number1" :from="1" :to="total_server" :format="theFormat" :duration="7"
          :delay="2" easing="Power1.easeOut" />
        <span v-else>{{ total_server }}</span>
      </font>
    </p>


    <div class="shard">
      <div class="item">
        <p>Connected:
          <number v-if="animatedCounter" ref="number1" :from="1" :to="40" :format="theFormat" :duration="4" :delay="1"
            easing="Power1.easeOut" />
        </p>
      </div>
      <div class="item">
        <p>Connecting: 0</p>
      </div>
      <div class="item">
        <p>Disconnected: 0</p>
      </div>
      <div class="item">
        <p>Shard reconnects: (No data)</p>
      </div>
    </div>

    <table v-if="showPresentData" class="styled-table">

      <thead>
        <tr>
          <th>
            <h3>
              <b>{{ today_ya_sekarang }}</b>
            </h3>
          </th>
          <th>
            <h3><b>Statistics</b></h3>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <h3>Current servers</h3>
          </td>
          <td>
            <h3>
              <number v-if="animatedCounter" ref="number1" :from="1" :to="today" :format="theFormat" :duration="7"
                :delay="2" easing="Power1.easeOut" />
              <span v-else>{{ today }}</span>
            </h3>
          </td>
        </tr>
        <tr class="active-row">
          <td>
            <h3>New servers</h3>
          </td>
          <td>
            <h3>
              +
              <number v-if="animatedCounter" ref="number1" :from="1" :to="today_growth" :format="theFormat" :duration="3"
                :delay="2" easing="Power1.easeOut" />
              <span v-else>{{ today_growth }}</span>
            </h3>
          </td>
        </tr>

        <tr class="active-row">
          <td>
            <h3>Current votes</h3>
          </td>
          <td>
            <h3>
              <number v-if="animatedCounter" ref="number1" :from="1" :to="total_votes" :format="theFormat" :duration="10"
                :delay="2" easing="Power1.easeOut" />
              <span v-else>{{ total_votes }}</span>
            </h3>
          </td>
        </tr>

        <tr class="active-row">
          <td>
            <h3>New votes</h3>
          </td>
          <td>
            <h3>
              +
              <number v-if="animatedCounter" ref="number1" :from="1" :to="today_votes" :format="theFormat" :duration="3"
                :delay="2" easing="Power1.easeOut" />
              <span v-else>{{ today_votes }}</span>
            </h3>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <p class="collapsible-button" @click="toggleTable">{{ isTableVisible ? 'Hide Table' : 'Jump to the table' }}</p>
    <br />
    <div style="overflow-x: auto;">

      <table :class="['collapsible-table', 'responsive-table', { 'show': isTableVisible }]" :id="'myTable'">
        <thead>
          <tr>
            <th>Data</th>
            <th>Last Bumped</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><a href="#monthlyGrowths">Scathach's monthly growth</a></td>
            <td>
              <h4>{{ bump_sejam }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#dailyGrowths">Scathach's daily growth</a></td>
            <td>
              <h4>{{ bump_sejam }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#hourlyGrowths">Scathach's hourly growth</a></td>
            <td>
              <h4>{{ bump_sejam }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#votesGrowth">Scathach's votes growth</a></td>
            <td>
              <h4>{{ bump_sejam }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#wsEvents1">Scathach's WS Events</a></td>
            <td>
              <h4>{{ bump_ws }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#wsEvents2">Scathach's WS Events</a></td>
            <td>
              <h4>{{ bump_ws }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#lavalinkServers">Lavalink &amp; ASMR Radio &amp; AI_Voice lines servers</a></td>
            <td>
              <h4>{{ bump_lavalink }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#lavalinkMemoryUsage">Lavalink memory usage</a></td>
            <td>
              <h4>{{ bump_lavalink }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#serversHealth">Servers health and memory usage</a></td>
            <td>
              <h4>{{ bump_sepuluhjam }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#serversNetwork">Servers network and traffic usage</a></td>
            <td>
              <h4>{{ bump_sepuluhjam }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#slashCommands">Scathach's popular slash commands</a></td>
            <td>
              <h4>{{ bump_sepuluhjam }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#prefixCommands">Scathach's popular commands</a></td>
            <td>
              <h4>{{ bump_sepuluhjam }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#musicFilters">Scathach's most music filters used</a></td>
            <td>
              <h4>{{ bump_sepuluhjam }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#triggerCommands">Scathach's most auto trigger used</a></td>
            <td>
              <h4>{{ bump_sepuluhjam }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#autoCommands">Scathach's most automated used</a></td>
            <td>
              <h4>{{ bump_sepuluhjam }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#oldAutoCommands"><strike>Old infrastructure</strike></a></td>
            <td>
              <h4>{{ bump_nodata }}</h4>
            </td>
          </tr>
          <tr>
            <td><a href="#premiumUsers">Scathach's premium users</a></td>
            <td>
              <h4>{{ bump_limamenit }}</h4>
            </td>
          </tr>

          <tr>
            <td><a href="#blockedUsers">Scathach's blocked users</a></td>
            <td>
              <h4>{{ bump_limamenit }}</h4>
            </td>
          </tr>

          <tr>
            <td><a href="#overallGrowth">Overall bot growth and its increments</a></td>
            <td>
              <h4>{{ bump_sejam }}</h4>
            </td>
          </tr>

          <tr>
            <td><a href="#howPeopleInteracts">How people interacts with Scathach</a></td>
            <td>
              <h4>{{ bump_sepuluhjam }}</h4>
            </td>
          </tr>

          <tr>
            <td><a href="#overallGrowth">Average Scathach growth in a day</a></td>
            <td>
              <h4>{{ bump_sepuluhjam }}</h4>
            </td>
          </tr>

        </tbody>
      </table>

    </div>


    <!--
    <div class="columns" style="text-align: left;">

      <div class="column" id="patreonInsight">
        <a href="#patreonInsight">
          <h1>Patreon dog</h1>
        </a>
        <h3>This data updates daily</h3>
        <BarChartPatreon :chart-data="datacollection"></BarChartPatreon>
      </div>
    </div>
    -->


    <div class="columns" style="text-align: left;">
      <div class="column" id="monthlyGrowths">
        <a href="#monthlyGrowths">
          <h1>Scathach's monthly growth</h1>
        </a>
        <h2>
          +
          <number v-if="animatedCounter" ref="number1" :from="1" :to="average_server_growth_monthly" :format="theFormat"
            :duration="6" :delay="2" easing="Power1.easeOut" />
          <span v-else>{{ average_server_growth_monthly }}</span>
          Servers
        </h2>
        <h3>Total Increments, updates hourly</h3>
        <line-chart></line-chart>
      </div>
      <div class="column" id="dailyGrowths">
        <a href="#dailyGrowths">
          <h1>Scathach's daily growth</h1>
        </a>
        <h2>
          +
          <number ref="number1" v-if="animatedCounter" :from="1" :to="average_server_growth_daily" :format="theFormat"
            :duration="3" :delay="1" easing="Power1.easeOut" />
          <span v-else>{{ average_server_growth_daily }}</span>
          Servers
        </h2>
        <h3>Daily Increments, updates hourly</h3>
        <bar-chart></bar-chart>
      </div>
    </div>
    <div class="columns" style="text-align: left;">
      <div class="column" id="hourlyGrowths">
        <a href="#hourlyGrowths">
          <h1>Scathach's hourly growth</h1>
        </a>
        <h2>
          +
          <number v-if="animatedCounter" ref="number1" :from="1" :to="average_server_growth_hourly" :format="theFormat"
            :duration="5" :delay="2" easing="Power1.easeOut" />
          <span v-else>{{ average_server_growth_hourly }}</span>
          Servers
        </h2>
        <h3>Hourly Increments, updates hourly</h3>
        <LineChartHourly></LineChartHourly>
        <h2>
          Approximate new servers in a day:
          <code>+{{ average_server_growth_daily }}</code>
        </h2>
      </div>
      <div class="column" id="votesGrowth">
        <a href="#votesGrowth">
          <h1>Scathach's votes growth</h1>
        </a>
        <h2>
          <number v-if="animatedCounter" ref="number1" :from="1" :to="average_votes_growth_monthly" :format="theFormat"
            :duration="10" :delay="2" easing="Power1.easeOut" />
          <span v-else>{{ average_votes_growth_monthly }}</span>
          /
          <number ref="number1" v-if="animatedCounter" :from="1" :to="total_votes" :format="theFormat" :duration="10"
            :delay="2" easing="Power1.easeOut" />
          <span v-else>{{ total_votes }}</span>
          votes
        </h2>
        <h3>Daily Increments, updates hourly</h3>
        <LineChartVotes :chart-data="datacollection"></LineChartVotes>
        <h2>
          Approximate
          <a
            href="https://support.top.gg/support/solutions/articles/73000528198-using-your-vote-credit#:~:text=What%20are%20Vote%20Credits%3F,vote%20credit%20as%20a%20reward.">Top.gg
            credits</a>: <code>{{ approximate_credits_rewards_monthly }}</code>
        </h2>
      </div>
    </div>




    <div class="columns">

      <div class="column" id="wsEvents1">
        <a href="#wsEvents1">
          <h1>Scathach's WS Events</h1>
        </a>
        <h2>
          This data collected since June 28 2023
        </h2>

        <center>
          <BarChartWs></BarChartWs>
        </center>
        <h3>Updates hourly</h3>
      </div>

      <div class="column" id="wsEvents2">
        <a href="#wsEvents2">
          <h1>Scathach's WS Events</h1>
        </a>
        <h2>
          This data collected since June 28 2023
        </h2>

        <center>
          <LineChartWs></LineChartWs>
        </center>
        <h3>Updates hourly</h3>
      </div>
    </div>

    <div class="columns" style="text-align: left;">

      <div class="column" id="lavalinkServers">
        <a href="#lavalinkServers">
          <h1>Lavalink & ASMR Radio & AI_Voice lines servers</h1>
        </a>
        <h3>This data updates in every 15 minutes</h3>
        <LineChartLavalink :chart-data="datacollection"></LineChartLavalink>
      </div>
    </div>

    <div class="columns" style="text-align: left;">

      <div class="column" id="lavalinkMemoryUsage">
        <a href="#lavalinkMemoryUsage">
          <h1>Lavalink memory usage</h1>
        </a>
        <h3>This data updates in every 15 minutes</h3>
        <LineChartLavalinkMemory></LineChartLavalinkMemory>
      </div>
    </div>

    <div class="columns" style="text-align: left;">

      <div class="column" id="serversHealth">
        <a href="#serversHealth">
          <h1>Servers health and memory usage</h1>
        </a>
        <h3>This data updates hourly</h3>
        <LineChartMemory :chart-data="datacollection"></LineChartMemory>
      </div>
    </div>

    <div class="columns" style="text-align: left;">

      <div class="column" id="serversNetwork">
        <a href="#serversNetwork">
          <h1>Servers network and traffic usage</h1>
        </a>
        <h3>This data updates hourly</h3>
        <LineChartNetwork :chart-data="datacollection"></LineChartNetwork>
      </div>
    </div>


    <div class="columns">

      <div class="column" id="slashCommands">
        <a href="#slashCommands">
          <h1>Scathach's popular slash commands</h1>
        </a>
        <h2>
          This data collected since February 4 2023
        </h2>

        <center>
          <BunderChartSlash></BunderChartSlash>
        </center>
        <h3>Updates daily</h3>
      </div>

      <div class="column" id="prefixCommands">
        <a href="#prefixCommands">
          <h1>Scathach's popular commands</h1>
        </a>
        <h2>
          This data collected since February 4 2023
        </h2>

        <center>
          <BunderChartCommands></BunderChartCommands>
        </center>
        <h3>Updates daily</h3>
      </div>

    </div>

    <div class="columns">

      <div class="column" id="musicFilters">
        <a href="#musicFilters">
          <h1>Scathach's most music filters used</h1>
        </a>
        <h2>
          This data collected since February 4 2023
        </h2>

        <center>
          <BunderChartMusic></BunderChartMusic>
        </center>
        <h3>Updates daily</h3>
      </div>

      <div class="column" id="triggerCommands">

        <a href="#triggerCommands">
          <h1>Scathach's most auto trigger used</h1>
        </a>
        <h2>
          This data collected since June 1 2023
        </h2>

        <center>
          <BunderChartTrigger></BunderChartTrigger>
        </center>
        <h3>Updates daily</h3>
      </div>

    </div>

    <div class="columns">

      <div class="column" id="autoCommands">
        <a href="#autoCommands">
          <h1>Scathach's most automated used</h1>
        </a>
        <h2>
          This data collected since February 4 2023
        </h2>

        <center>
          <BunderChartAuto></BunderChartAuto>
        </center>
        <h3>Updates daily</h3>
      </div>

      <div class="column" id="oldAutoCommands">
        <a href="#oldAutoCommands">
          <h1><strike>Old infrastructure</strike></h1>
        </a>
        <h2>
          <strike>This data collected since February 4 2023</strike>
        </h2>

        <center>
          <PieChart></PieChart>
        </center>
        <h3>Updates daily</h3>
      </div>


    </div>





    <div class="columns">

      <div class="column" id="premiumUsers">
        <a href="#premiumUsers">
          <h1>Scathach's premium users</h1>
        </a>
        <h2>
          <number v-if="animatedCounter" ref="number1" :from="1" :to="premium" :format="theFormat" :duration="10"
            :delay="2" easing="Power1.easeOut" />
          <span v-else>{{ premium }}</span>

          Users / Servers
        </h2>

        <center>
          <DoughnutChart :style="{ width: '80%' }"></DoughnutChart>
        </center>
        <h3>Updates when new item emits</h3>
      </div>


      <div class="column" id="blockedUsers">
        <a href="#blockedUsers">
          <h1>Scathach's blocked users</h1>
        </a>
        <h2>
          <number v-if="animatedCounter" ref="number1" :from="1" :to="block" :format="theFormat" :duration="10" :delay="2"
            easing="Power1.easeOut" />
          <span v-else>{{ block }}</span>

          Users / Servers
        </h2>

        <center>
          <DoughnutChartBlocked :style="{ width: '80%' }"></DoughnutChartBlocked>
        </center>
        <h3>Updates when new item emits</h3>
      </div>


    </div>

    <!--
    <div class="columns" style="text-align: left;">

      <div class="column">
        <h1>Autocommands tasks active</h1>
        <h3>auto and jobs that scheduled deliver in a day, updates daily</h3>
        <LineChartAutomation :chart-data="datacollection"></LineChartAutomation>
      </div>
    </div>
  -->





    <div class="columns" style="text-align: left;">

      <div class="column" id="overallGrowth">
        <a href="#overallGrowth">
          <h1>Overall bot growth and its increments</h1>
        </a>
        <h3>This data updates daily</h3>
        <LineChartOverall :chart-data="datacollection"></LineChartOverall>
      </div>
    </div>

    <div class="columns">
      <div class="column" id="howPeopleInteracts">
        <a href="#howPeopleInteracts">
          <h1>How people interacts with Scathach</h1>
        </a>
        <h2>
          This data collected since June 1 2023
        </h2>

        <center>
          <BunderChartPrefer></BunderChartPrefer>
        </center>

      </div>

      <div class="column" id="averageGrowth">
        <a href="#averageGrowth">
          <h1>Average Scathach growth in a day</h1>
        </a>
        <h2>
          This data collected since February 4 2023
        </h2>

        <center>
          <BunderChartAverage></BunderChartAverage>
        </center>

      </div>

    </div>






    <div v-if="showPredictsData" id="predicts">
      <br>
      <a href="#predicts">
        <h1>The data predicts</h1>
      </a>
      <br>
      <table class="styled-table">
        <thead>
          <tr>
            <th>
              <h3>
                <b>{{ name }} bot</b>
              </h3>
            </th>
            <th>
              <h3><b>Approximate / Can be more and less</b></h3>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <h2>After 3 months</h2>
            </td>
            <td>
              <h2>
                <img :src="avatar" class="small-avatar" /> {{ name }} should
                get
                <number ref="number1" :from="1" :to="approximate_server_growth_three_months" :format="theFormat"
                  :duration="5" :delay="1" easing="Power1.easeOut" />
                new servers in the next 3 months
              </h2>
            </td>
          </tr>
          <tr class="active-row">
            <td>
              <h2>After 6 months</h2>
            </td>
            <td>
              <h2>
                <img :src="avatar" class="small-avatar" /> {{ name }} should
                get
                <number ref="number1" :from="1" :to="approximate_after_6" :format="theFormat" :duration="5" :delay="1"
                  easing="Power1.easeOut" />
                new servers in the next 6 months
              </h2>
            </td>
          </tr>

          <tr class="active-row">
            <td>
              <h2>After a year</h2>
            </td>
            <td>
              <h2>
                <img :src="avatar" class="small-avatar" /> {{ name }} should
                get
                <number ref="number1" :from="1" :to="approximate_server_growth_annually" :format="theFormat"
                  :duration="10" :delay="2" easing="Power1.easeOut" />
                new servers in the next year
              </h2>
            </td>
          </tr>

          <tr class="active-row">
            <td>
              <h2>Total servers (A year later)</h2>
            </td>
            <td>
              <h2>
                <img :src="avatar" class="small-avatar" /> {{ name }} should
                get
                <number ref="number1" :from="1" :to="estimate_total_server_in_the_next_year" :format="theFormat"
                  :duration="10" :delay="2" easing="Power1.easeOut" />total servers
              </h2>
            </td>
          </tr>

          <tr class="active-row">
            <td>
              <h2>Total servers (3 years later)</h2>
            </td>
            <td>
              <h2>
                <img :src="avatar" class="small-avatar" /> {{ name }} should
                get
                <number ref="number1" :from="1" :to="estimate_total_server_in_the_3_years" :format="theFormat"
                  :duration="10" :delay="2" easing="Power1.easeOut" />total servers
              </h2>
            </td>
          </tr>

          <tr class="active-row">
            <td>
              <h2>Monthly rewards</h2>
            </td>
            <td>
              <h2>
                <img :src="avatar" class="small-avatar" /> {{ name }}'s dev should
                get {{ approximate_credits_rewards_monthly }} on Top.gg credits
              </h2>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- if predictsTable true, show <div> available </> -->

    <br /><br />

  </section>
</template>

<script>
import moment from "moment";
import axios from "axios";
import LineChart from "@/components/LineChart";
import BarChart from "@/components/BarChart";
import LineChartHourly from "@/components/LineChartHourly";
import LineChartVotes from "@/components/LineChartVotes";
import DoughnutChart from "@/components/DoughnutChart";
import DoughnutChartBlocked from "@/components/DoughnutChartBlocked";
import PieChart from "@/components/PieChart";
import LineChartOverall from "@/components/LineChartOverall";
import LineChartMemory from "@/components/LineChartMemory";
import LineChartNetwork from "@/components/LineChartNetwork";
import BunderChartSlash from "@/components/BunderChartSlash";
import BunderChartCommands from "@/components/BunderChartCommands";
import BunderChartPrefer from "@/components/BunderChartPrefer";
import BunderChartAverage from "@/components/BunderChartAverage";
import BunderChartMusic from "@/components/BunderChartMusic";
import BunderChartTrigger from "@/components/BunderChartTrigger";
import BunderChartAuto from "@/components/BunderChartAuto";
import BarChartWs from "@/components/BarChartWs";
import LineChartWs from "@/components/LineChartWs";
import LineChartLavalink from "@/components/LineChartLavalink";
import LineChartLavalinkMemory from "@/components/LineChartLavalinkMemory";
// import BarChartPatreon from "@/components/BarChartPatreon";

import { inMemoryBotInfo, bumpInfo } from "../base";
import PageLoader from "@/components/PageLoader";
import {
  showPredictsData, showPresentData,
  topggExternalButton, animatedCounter
} from "../../config";



export default {
  name: "VueChartJS",
  components: {
    PageLoader,
    LineChart,
    BarChart,
    LineChartHourly,
    LineChartVotes,
    DoughnutChart,
    DoughnutChartBlocked,
    PieChart,
    LineChartOverall,
    LineChartMemory,
    LineChartNetwork,
    BunderChartSlash,
    BunderChartCommands,
    BunderChartPrefer,
    BunderChartAverage,
    BunderChartMusic,
    BunderChartTrigger,
    BunderChartAuto,
    BarChartWs,
    LineChartWs,
    LineChartLavalink,
    LineChartLavalinkMemory,
    // BarChartPatreon
  },
  data() {
    return {
      isTableVisible: false,
      avatar: "https://cdn.discordapp.com/embed/avatars/0.png",
      topgglink: null,
      datacollection: null,
      name: "Loading",
      description: null,
      average_server_growth_monthly: null,
      average_server_growth_daily: null,
      average_server_growth_hourly: null,
      total_votes: null,
      total_server: null,
      average_votes_growth_monthly: null,
      approximate_server_growth_three_months: null,
      approximate_credits_rewards_monthly: null,
      approximate_server_growth_annually: null,
      today: null,
      today_growth: null,
      today_ya_sekarang: null,
      today_votes: null,
      approximate_after_6: null,
      estimate_total_server_in_the_next_year: null,
      estimate_total_server_in_the_3_years: null,
      estimate_total_server_in_the_5_years: null,
      premium: null,
      block: null,
      rata_rata_seminggu: null,
      bump_ws: "NaN",
      bump_lavalink: "NaN",
      bump_sepuluhjam: "NaN",
      bump_sejam: "NaN",
      bump_limamenit: "NaN",
      bump_nodata: "NaN",
    };
  },
  async created() {
    // redirect everything to /
    if (window.location.pathname !== "/") {
      window.location.href = "/";
    }

    this.fillData();
    await inMemoryBotInfo().then((response) => {
      this.avatar = response.data.avatar;
      this.name = response.data.title;
      this.total_votes = response.data.total_votes;
      this.total_server = response.data.server_count;
      this.description = response.data.description;
      this.average_server_growth_monthly =
        response.average_server_growth_monthly;
      this.average_server_growth_daily = response.average_server_growth_daily;
      this.average_server_growth_hourly = response.average_server_growth_hourly;
      this.average_votes_growth_monthly = response.average_votes_growth_monthly;
      this.approximate_server_growth_three_months =
        response.approximate_server_growth_three_months;
      this.approximate_credits_rewards_monthly =
        response.approximate_credits_rewards_monthly;
      this.approximate_server_growth_annually =
        response.approximate_server_growth_annually;
      this.today = response.stats_daily[0].total_server;
      this.today_growth = response.stats_daily[0].server_growth;
      this.today_ya_sekarang = response.stats_daily[0].date;
      this.topgglink = `https://top.gg/bot/${response.data.id}`;
      this.today_votes = response.stats_daily[0].votes_growth;
      this.approximate_after_6 = response.average_server_growth_monthly * 6;
      this.estimate_total_server_in_the_next_year =
        response.data.server_count +
        response.approximate_server_growth_annually;
      this.showPredictsData = showPredictsData;
      this.showPresentData = showPresentData;
      this.topggExternalButton = topggExternalButton;
      this.animatedCounter = animatedCounter;
      this.estimate_total_server_in_the_3_years =
        response.approximate_server_growth_annually * 3 + response.data.server_count;
      this.rata_rata_seminggu = response.average_server_growth_daily * 8;
    });

    await bumpInfo().then((res) => {
      function formatDate(date) {
        const momentDate = moment(date);
        const formattedDate = momentDate.format("HH:mm A, D MMMM");
        const timeAgo = momentDate.fromNow();

        return formattedDate + " (" + timeAgo + ")";
      }

      this.bump_ws = formatDate(res.ws);
      this.bump_lavalink = formatDate(res.lavalink);
      this.bump_sepuluhjam = formatDate(res.sepuluhjam);
      this.bump_sejam = formatDate(res.sejam);
      this.bump_limamenit = formatDate(res.limamenit);
      this.bump_nodata = res.nodata;

    });

    await axios
      .get("https://scathachbot.xyz/api/userpremium")
      .then((res) => {
        let pro = res.data;
        //get all value from pro object
        let proValues = Object.values(pro);

        //tambahkan semua nilai dari proValues
        let total = proValues.reduce((a, b) => a + b, 0);
        this.premium = total;
      })
      .catch((error) => {
        console.log(error);
        alert("Error: " + error);
      });

    await axios
      .get("https://scathachbot.xyz/api/userblocked")
      .then((res) => {
        let block = res.data;
        //get all value from pro object
        let blockValues = Object.values(block);

        //tambahkan semua nilai dari proValues
        let total = blockValues.reduce((a, b) => a + b, 0);
        this.block = total;
      })
      .catch((error) => {
        console.log(error);
        alert("Error: " + error);
      });
  },
  methods: {
    toggleTable() {
      this.isTableVisible = !this.isTableVisible;
    },

    fillData() {
      this.datacollection = null;
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    theFormat(number) {
      let nf = new Intl.NumberFormat("en-US");
      return nf.format(number.toFixed(0));
    },
    completed() {
      console.log("Animation ends!");
    },
    playAnimation() {
      this.$refs.number2.play();
    },
  },
};
</script>
<style>
@keyframes float {
  0% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    transform: translatey(0px);
  }

  50% {
    box-shadow: 0 25px 15px 0px rgba(0, 0, 0, 0.2);
    transform: translatey(-20px);
  }

  100% {
    box-shadow: 0 5px 15px 0px rgba(0, 0, 0, 0.6);
    transform: translatey(0px);
  }
}

.avatar {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  box-sizing: border-box;
  overflow: hidden;
  transform: translatey(0px);
  animation: float 6s ease-in-out infinite;
}

.small-avatar {
  vertical-align: middle;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  box-sizing: border-box;
  overflow: hidden;
  border: 3px solid #22b99b;
}

.styled-table {
  margin-left: auto;
  margin-right: auto;
  border-collapse: collapse;

  font-size: 0.9em;
  /*
  font-family: "Helvetica Neue";
  */
  min-width: 400px;
  border: 1px solid rgb(241, 216, 73);

}

.styled-table thead tr {
  background-color: #22b99b;
  color: #ffffff;
  text-align: left;

}

.styled-table th,
.styled-table td {
  padding: 12px 15px;
}

.shard {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.item {
  padding: 10px;
  border: 1px solid gold;
  border-radius: 8px;
}

@media only screen and (max-width: 600px) {
  .container {
    flex-direction: column;
  }
}

.responsive-img {
  max-width: 100%;
  height: auto;
}

.responsive-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  border: 1px solid #ddd;

}

.responsive-table th,
.responsive-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

.responsive-table th {
  background-color: #f2f2f2;
  color: #333;
}

.responsive-table tr:hover {
  background-color: #00ff6a52;
}

.collapsible-button {
  display: block;
  width: 100%;
  background-color: #4CAF50;
  border: 1px solid #4CAF50;
  border-radius: 10px;
  color: white;
  padding: 8px 16px;
  cursor: pointer;
  transition: background-color 0.3s;
  text-align: center;
  /* Center the text */
  box-sizing: border-box;
  /* Include padding and border in the total width */
}

.collapsible-button:hover {
  background-color: #45a049;
}

.collapsible-table {
  border-collapse: collapse;
  width: 100%;
  margin-top: 20px;
  border-radius: 4px;
  overflow: hidden;
  display: none;
}

.collapsible-table.show {
  display: table;
  animation: slideIn 0.5s ease-in-out;
}

.collapsible-table.hide {
  animation: slideOut 0.5s ease-in-out forwards;
}

@keyframes slideIn {
  0% {
    transform: translateY(-100%);
  }

  100% {
    transform: translateY(0);
  }
}

@keyframes slideOut {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-100%);
  }
}


.collapsible-table th,
.collapsible-table td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.collapsible-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.collapsible-table tr:last-child td {
  border-bottom: none;
}</style>
